// import libraries
import React from 'react';
import toastr from 'toastr';
import * as Sentry from '@sentry/react';
import Amplify, { Auth, Hub } from 'aws-amplify';
import { Button, Input, Form, Modal, Icon } from 'semantic-ui-react';
import { Authenticator } from 'aws-amplify-react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import '@aws-amplify/ui/dist/style.css';
import './AppwWthAuth.css';
import { Provider } from 'react-redux';
import Joyn2Button from './components/common/Joyn2Button';
import App from './App';
import configureStore from './store/configureStore';
import awsConfig from './aws-exports';
import AuthUtilities from './HelperMethods/AuthUtilities';
import background from './common/assets/login-screen.png';
import logo from './common/assets/WEnergy-FSM-logo2.png';
import { ENTER_KEY_CODE, KEY_PRESS_DOWN } from './HelperMethods/enums';
import ForgotPasswordComponent from './ForgotPasswordScreen';
import ApiService from './service/apiService';
import { actionRecordUtils } from './HelperMethods/LocalStorageUtils';
import { zlibDeflate } from './HelperMethods/UtilityFunctions';

const isAiBuild = process.env.REACT_APP_ENVIRONMENT.includes('ai');

Amplify.configure(awsConfig);
const oauth = {
  domain: awsConfig.adfs.domain,
  scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
  redirectSignIn: awsConfig.adfs.redirectURL,
  redirectSignOut: awsConfig.adfs.redirectURL,
  responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
};
Auth.configure({ oauth });

const store = configureStore();
const emailRegexTest =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const getConfigfromlink = async (link) => {
  try {
    const response = await fetch(link);
    return response.json();
  } catch (error) {
    return error;
  }
};

const adfsLoginLinkCreator = async (enterpriseName) => {
  const { REACT_APP_ENVIRONMENT: env } = process.env;
  const suffix = env === 'prod' ? '' : `-${env}`;
  const configLink = `https://joynfsm${suffix}.s3.us-west-2.amazonaws.com/config/${enterpriseName}.json`;

  try {
    const awsConfigFile = await getConfigfromlink(configLink);
    const redirectURL = _.get(awsConfigFile, 'adfs.redirectURL', awsConfig.adfs.redirectURL);
    const domain = _.get(awsConfigFile, 'adfs.domain', awsConfig.adfs.domain);
    const userPoolId = _.get(awsConfig, 'Auth.userPoolWebClientId');
    const { idProvider } = awsConfigFile?.adfs;
    const adfsUrl = `https://${domain}/oauth2/authorize?response_type=code&client_id=${userPoolId}&redirect_uri=${redirectURL}&idp_identifier=${idProvider}`;

    oauth.domain = domain;
    oauth.redirectSignIn = redirectURL;
    const headerLinks = awsConfigFile.headerLinks || {};
    localStorage.setItem('HEADER_DETAILS', JSON.stringify(headerLinks));

    Auth.configure({ oauth });
    return {
      success: true,
      message: adfsUrl,
    };
  } catch (error) {
    return { success: false, message: 'Company name not found' };
  }
};

const CustomSignUp = (props) => {
  const providerNamefromLocalStorage = !_.isEmpty(localStorage.getItem('PROVIDER_NAME'))
    ? localStorage.getItem('PROVIDER_NAME')
    : props.providerName;
  const [email, setemail] = React.useState('');
  const [enterpriseError, setenterpriseError] = React.useState('');
  const [enterpriseText, setenterpriseText] = React.useState(providerNamefromLocalStorage);
  const [password, setPassword] = React.useState('');
  const [emailState, setemailState] = React.useState(true);
  const [emailError, setemailError] = React.useState('');
  const [passwordError, setpasswordError] = React.useState('');
  const [ModalVisibleState, setModalVisibleState] = React.useState(null);
  const [onClickState, setonClickState] = React.useState(null);
  const [loginButtonLoading, setloginButtonLoading] = React.useState(false);
  const [forgotPassword, setForgotPassword] = React.useState(false);

  const adfsLogin = async () => {
    localStorage.setItem('PROVIDER_NAME', enterpriseText);

    const adfsUrlState = await adfsLoginLinkCreator(enterpriseText);
    if (adfsUrlState.success) {
      const adfsUrl = adfsUrlState.message;
      window.location.href = adfsUrl;
    } else {
      setenterpriseError(adfsUrlState.message);
    }
  };

  const textClassNamefadeIn = 'inputText fadeInClass';
  const textClassNamefadeOut = 'inputText fadeOutClass';
  const inputstylefadeIn = 'inputstyle fadeInClass';
  const inputstylefadeOut = 'inputstyle fadeOutClass';

  const nonAdfslogin = () => {
    localStorage.setItem('PROVIDER_NAME', '');
    setemailState(false);
  };
  const onClickEffect = (event) => {
    if (event.target.name === 'email') {
      setonClickState(false);
      setenterpriseText('');
    } else {
      setonClickState(true);
      setemail('');
    }
  };

  const adfsLoginCheck = async () => {
    if (onClickState && enterpriseText) {
      await adfsLogin(enterpriseText);
    } else if (onClickState && _.isEmpty(enterpriseText)) {
      setenterpriseError('Company name is empty');
      setemailError('');
    }
  };
  const nonadfsLoginCheck = async () => {
    if (!onClickState && (!emailRegexTest.test(email) || _.isEmpty(email))) {
      setenterpriseError('');
      setemailError('Not a valid email');
    } else if (!onClickState && !_.isEmpty(email)) {
      nonAdfslogin();
    }
  };

  const finalAdfsLogin = async () => {
    setpasswordError('');
    try {
      setloginButtonLoading(true);
      await Auth.signIn(email, password);
      setloginButtonLoading(false);
    } catch (e) {
      setloginButtonLoading(false);
      const errorMessage = e.message || 'Something went wrong';
      setpasswordError(errorMessage);
      setPassword('');
    }
  };
  const keyPress = async (e, clickState) => {
    if (e.type === KEY_PRESS_DOWN && e.keyCode === ENTER_KEY_CODE && clickState) {
      adfsLoginCheck();
    } else if (e.type === KEY_PRESS_DOWN && e.keyCode === ENTER_KEY_CODE && !clickState) {
      nonadfsLoginCheck();
    }
  };

  const signinComponents = () => {
    return emailState ? (
      <>
        <div style={{ fontWeight: 'bold', fontSize: '18px', color: '#4c4c4c' }}>
          Choose your Company or Email to proceed
        </div>
        <div style={{ marginTop: '30px' }}>
          <div className={onClickState ? textClassNamefadeIn : textClassNamefadeOut}>Company</div>
          <div>
            <Form.Field style={{ width: '100%' }}>
              <Input
                type="text"
                name="comapnyText"
                className={onClickState ? inputstylefadeIn : inputstylefadeOut}
                // style={onClickState ? { opacity: '0.3' } : { opacity: '1' }}
                onKeyDown={(e) => {
                  keyPress(e, onClickState);
                }}
                icon={
                  <Icon
                    name="sign-in"
                    link={onClickState}
                    onClick={() => {
                      adfsLoginCheck();
                    }}
                  />
                }
                onChange={(event) => {
                  setenterpriseText(event.target.value);
                }}
                onClick={onClickEffect}
                value={enterpriseText}
              />
            </Form.Field>
            {enterpriseError && <div style={{ color: 'red' }}>{enterpriseError}</div>}
          </div>
        </div>
        <div>
          <div className={onClickState ? textClassNamefadeOut : textClassNamefadeIn}>Enter your Email to proceed</div>
          <Form.Field style={{ width: '100%' }}>
            <Input
              type="email"
              name="email"
              icon={
                <Icon
                  name="sign-in"
                  link={!onClickState}
                  onClick={() => {
                    nonadfsLoginCheck();
                  }}
                />
              }
              onKeyDown={(e) => {
                keyPress(e, onClickState);
              }}
              className={onClickState ? inputstylefadeOut : inputstylefadeIn}
              onChange={(event) => setemail(event.target.value)}
              value={email}
              onClick={onClickEffect}
            />
          </Form.Field>
          {emailError && <div style={{ color: 'red' }}>{emailError}</div>}
        </div>
        <div style={{ textAlign: 'center' }}>
          <u
            className="p-cursor"
            onClick={() => {
              setForgotPassword(true);
            }}
          >
            Forgot Password
          </u>
        </div>
      </>
    ) : (
      <>
        <div style={{ fontWeight: 'bold', fontSize: '18px', color: '#4c4c4c' }}>Enter your Password to proceed</div>
        <Form.Field style={{ width: '100%' }}>
          <Input
            type="password"
            onChange={(event) => setPassword(event.target.value)}
            name="password"
            value={password}
            style={{ width: '100%' }}
            onKeyDown={async (e) => {
              if (e.type === KEY_PRESS_DOWN && e.keyCode === ENTER_KEY_CODE && e.target.name === 'password') {
                await finalAdfsLogin();
              }
            }}
          />
        </Form.Field>
        {passwordError && <div style={{ color: 'red' }}>{passwordError}</div>}
        <div>
          <Button
            style={{ width: '105px', background: '#424f62', color: 'white' }}
            onClick={() => {
              setemailState(true);
            }}
            disabled={loginButtonLoading}
          >
            Back
          </Button>
          <Button
            style={{ width: '105px', background: '#424f62', color: 'white' }}
            name="next"
            loading={loginButtonLoading}
            onClick={async () => {
              if (!password) {
                setpasswordError('Password field is Empty');
              } else {
                await finalAdfsLogin();
              }
            }}
          >
            Next
          </Button>
        </div>
      </>
    );
  };

  return (
    <div>
      {props.loading ? (
        <div>
          <div className="joyn2-loader" />
        </div>
      ) : null}
      {!props.loading && props.authState === 'signIn' && (
        <div style={{ display: 'flex', height: '100vh', width: '100vw' }}>
          <div
            style={{ backgroundImage: `url(${background})`, height: '100%', width: '50%', backgroundSize: 'cover' }}
          />
          <div
            style={{
              height: '100%',
              width: '50%',
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Modal size="mini" open={ModalVisibleState}>
              <Modal.Header>
                <div>Error</div>
              </Modal.Header>
              <Modal.Content>
                <div
                  className="select"
                  name="email"
                  onClick={() => {
                    setModalVisibleState(false);
                    nonAdfslogin();
                  }}
                >
                  Email Login : {email}
                </div>
                <div
                  className="select"
                  name="enterprise"
                  onClick={async () => {
                    await adfsLogin();
                  }}
                >
                  Enterprise Login : {enterpriseText}
                </div>
              </Modal.Content>
              <Modal.Actions>
                <div style={{ display: 'flex', float: 'right', padding: '10px' }}>
                  <Joyn2Button
                    margin="0 10px 0 0"
                    size="large"
                    label="Cancel"
                    color="light"
                    type="button"
                    btnType="secondary"
                    onClick={() => {
                      setModalVisibleState(false);
                    }}
                  />
                </div>
              </Modal.Actions>
            </Modal>
            <div style={{ position: 'absolute', top: '12%', display: 'flex', justifyContent: 'center', width: '100%' }}>
              <img src={logo} style={{ height: '70px', width: '270px' }} />
            </div>
            <div
              style={
                emailState
                  ? { display: 'flex', justifyContent: 'space-around', flexDirection: 'column', height: '250px' }
                  : { display: 'flex', justifyContent: 'space-around', flexDirection: 'column', height: '150px' }
              }
            >
              {forgotPassword ? (
                <ForgotPasswordComponent setForgotPassword={setForgotPassword} email={email} />
              ) : (
                signinComponents()
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

Hub.listen('auth', async ({ payload: { event, data } }) => {
  const { origin } = window.location || {};
  const logouturl = isAiBuild ? '/logout' : '/joynfsm/index.html';
  const signOutUrl = `${origin}${logouturl}`;
  switch (event) {
    case 'cognitoHostedUI':
      window.location.href = `${origin}/joynfsm/taskViewPage`;
      break;
    case 'oAuthSignOut':
    case 'signOut':
      window.location.href = signOutUrl;
      break;

    default:
      break;
  }
});

// get the environment from url and set it in localStorage
function envAssimilator(hostName) {
  const string = hostName;

  try {
    const providerName = string.split('.')[0];
    if (providerName) {
      localStorage.setItem('PROVIDER_NAME', providerName);

      return providerName;
    }
    return '';
  } catch (e) {
    console.log(e);
    return '';
  }
}

const ErrorDialog = (props) => {
  const { error, display, onChange } = props;

  return (
    error && (
      <Modal size="mini" open={display}>
        <Modal.Header>
          <div>Error</div>
        </Modal.Header>
        <Modal.Content>
          <div>{error}</div>
        </Modal.Content>
        <Modal.Actions>
          <div style={{ display: 'flex', float: 'right', padding: '10px' }}>
            <Joyn2Button
              margin="0 10px 0 0"
              size="large"
              label="Cancel"
              color="light"
              type="button"
              btnType="secondary"
              onClick={() => {
                onChange();
              }}
            />
          </div>
        </Modal.Actions>
      </Modal>
    )
  );
};
class AppWithAuth extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      tenantId: null,
      username: null,
      vendorId: null,
      providerName: '',
      errorMessage: '',
      display: false,
      loading: false,
    };

    this.updateLoggedInUserInfo = this.updateLoggedInUserInfo.bind(this);
  }

  async componentDidMount() {
    this.addingTitle();
    const providerName = envAssimilator(window.location.hostname);
    const urlParams = new URLSearchParams(window.location.search);
    let pathName = window?.location?.pathname ?? '';
    let redirectPath = `${origin}`;
    let autologinparam = '';
    if (pathName.startsWith('/joynfsm/')) {
      pathName = pathName.substring(9);
      redirectPath = `${redirectPath}/joynfsm`;
      if (pathName.startsWith('eJ')) {
        autologinparam = zlibDeflate(pathName);
      }
    } else if (pathName.startsWith('/')) {
      pathName = pathName.substring(1);
      if (pathName.startsWith('eJ')) {
        autologinparam = zlibDeflate(pathName);
      }
    }
    if (autologinparam && autologinparam.redirectId && autologinparam.autoLogin) {
      this.setState({ loading: true });
      const { redirectId } = autologinparam;
      try {
        toastr.info('Auto logging...');
        const response = await ApiService.getAutologinCredential({ redirectId });
        const { token, actionRecord } = response;
        toastr.success('Auto logging success');
        actionRecordUtils.SET_ACTION_RECORD(actionRecord);
        if (token) {
          Object.keys(token).forEach((key) => {
            localStorage.setItem(key, token[key]);
          });
        }
        window.location.href = `${redirectPath}/taskViewPage/task/update/${actionRecord.entityId}`;
      } catch (error) {
        window.location.href = `${origin}/joynfsm`;
        toastr.error('Auto logging Failed');
      } finally {
        this.setState({ loading: false });
      }
    }
    const errorMessage = urlParams.get('error') || urlParams.get('error_description');
    if (errorMessage) {
      this.setState({
        errorMessage,
        display: true,
      });
    }
    if (providerName) {
      this.setState((prevState) => {
        return {
          ...prevState,
          providerName,
        };
      });
    }
  }

  componentWillUnmount() {
    localStorage.removeItem('actionRecord');
  }

  addingTitle = () => {
    const tempTitle = document.querySelector('head > title');
    tempTitle.innerText = 'Joyn FSM';
  };

  async updateLoggedInUserInfo() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      AuthUtilities.expiryTime = user.getSignInUserSession().getIdToken().payload.exp;
      Amplify.configure({
        API: {
          graphql_headers: async () => ({
            Authorization: user.getSignInUserSession().getIdToken().getJwtToken(),
          }),
        },
      });
      const tenantId = user.attributes['custom:tenant_id'];
      const vendorId = user.attributes['custom:vendor_id'];
      const username = awsConfig.adfsEnabled ? user.attributes.email : user.username;

      // eslint-disable-next-line no-underscore-dangle
      window._mfq.push(['setVariable', 'username', username]);
      // eslint-disable-next-line no-undef

      this.setState({
        tenantId,
        username,
        vendorId,
      });
    } catch (err) {
      console.log(err);
    }
  }

  displayChange() {
    this.setState(
      {
        display: false,
      },
      () => {
        window.location.href = isAiBuild ? `/login` : `/joynfsm/index.html`;
      }
    );
  }

  render() {
    const { tenantId, username, vendorId, loading } = this.state;
    const { history } = this.props;
    return (
      <Provider store={store}>
        <Authenticator
          authState="signIn"
          onStateChange={(authState) => {
            // once user is signedIn
            if (authState === 'signedIn') {
              this.updateLoggedInUserInfo();
            }
          }}
          hideDefault
        >
          <ErrorDialog
            error={this.state.errorMessage}
            display={this.state.display}
            onChange={() => {
              this.displayChange();
            }}
          />
          <CustomSignUp override="SignIn" providerName={this.state.providerName} loading={loading} />
          <>
            {loading && <div className="joyn2-loader" />}

            {tenantId && (
              <Sentry.ErrorBoundary>
                <App store={store} vendorId={vendorId} tenantId={tenantId} userName={username} history={history} />
              </Sentry.ErrorBoundary>
            )}
          </>
        </Authenticator>
      </Provider>
    );
  }
}

AppWithAuth.propTypes = {
  history: PropTypes.object.isRequired,
};
// make this component available to the app
export default AppWithAuth;
